import styled from 'styled-components';
import { Div } from 'styles/elements/div';

export const HOME_BUTTON_MARGIN = 20;

export const Button = styled(Div)`
  border: 1px solid ${props => props.theme.brandingPrimaryShadeFive};
  color: black;
  border-radius: 10px;
  padding: 24px;
  margin: ${HOME_BUTTON_MARGIN}px;
  cursor: pointer;
  flex-basis: calc(50% - ${HOME_BUTTON_MARGIN * 2}px);
  box-sizing: border-box;
  justify-content: space-between;
`;
